<div class="modal-header">
   <h3 class="heading-special-3" translate="cart.shareable.welcome.title"></h3>
</div>
<div class="modal-body" id="modal-body">
    <div *ngIf="!!freeShippingMsg">
        <div>{{freeShippingMsg}}</div>
        <br>
        <span translate="cart.some.exclusions.apply"></span>
    </div>
    <div *ngIf="!freeShippingMsg">
        <div [translate]="welcomeMessage"></div>
    </div>
    <div class="social-welcome-locale margin-top-16" *ngIf="!authenticated">
        <span translate="cart.share.locale.confirm"></span>
        <button class="btn btn-default" type="button" (click)="showLocalesPicker = !showLocalesPicker">
            <flag-icon [localeCountry]="currentLocaleData?.country"></flag-icon>
            <span>{{currentLocaleData?.countryDisplay}} - {{currentLocaleData?.languageDisplay}}</span> <span data-testid="cart.share.locale.dropdown" class="fa-solid fa-chevron-down"></span></button>
    </div>
    <div [hidden]="!showLocalesPicker">
        <locale-list [onSelectLocale]="confirmLocale" autoSelectUserLocale="true" (currentLocaleData)="onCurrentLocaleData($event)" (localeEvent)="onLocaleChange($event)"></locale-list>
    </div>
    <div class="button-container margin-top-32" *ngIf="!showLocalesPicker">
        <button class="button button-primary" type="button" (click)="confirmClicked()" translate="cart.confirm.ok"></button>
    </div>
</div>

